<template>
  <div class="mobile-fullscreen-camera">
    <div class="mobile-header">
      <button
        type="button"
        class="close-btn"
        @click="$emit('close')"
      >
        <i class="fas fa-times" />
      </button>
      <h5 class="header-title">
        Posicione seu rosto no oval
      </h5>
    </div>

    <div class="camera-fullscreen-container">
      <face-detection-overlay
        :is-detecting="isDetecting"
        :face-detected="faceDetected"
        :face-inside-oval="faceInsideOval"
        :is-mobile="true"
      />

      <div class="camera-video-container">
        <v-easy-camera
          id="mobile-video"
          ref="easyCamera"
          v-model="picture"
          :width="640"
          :height="480"
          :autoplay="false"
          class="mobile-camera-video"
          @approve="$emit('picture-ready')"
        />
        <canvas
          id="mobile-overlay"
          width="640"
          height="480"
          class="mobile-overlay-canvas"
        />

        <face-guide-overlay
          :is-mobile="true"
          :face-detected="faceDetected && faceInsideOval"
        />
      </div>
    </div>

    <div class="mobile-footer">
      <button
        type="button"
        class="mobile-capture-button"
        :disabled="isCapturing || !(faceDetected && faceInsideOval)"
        @click="$emit('capture')"
      >
        <div class="capture-button-content">
          <i
            v-if="!isCapturing"
            class="fas fa-camera"
          />
          <i
            v-else
            class="fas fa-spinner fa-spin"
          />
          <span>{{ isCapturing ? 'Processando...' : 'Marcar Ponto' }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import EasyCamera from 'easy-vue-camera'
import FaceDetectionOverlay from './FaceDetectionOverlay.vue'
import FaceGuideOverlay from './FaceGuideOverlay.vue'

export default {
  name: 'MobileCamera',
  components: {
    'v-easy-camera': EasyCamera,
    FaceDetectionOverlay,
    FaceGuideOverlay,
  },
  props: {
    isDetecting: {
      type: Boolean,
      default: false,
    },
    faceDetected: {
      type: Boolean,
      default: false,
    },
    faceInsideOval: {
      type: Boolean,
      default: false,
    },
    isCapturing: {
      type: Boolean,
      default: false,
    },
    picture: {
      type: String,
      default: '',
    },
  },
  emits: ['capture', 'close', 'picture-ready'],
}
</script>

<style scoped>
/* Container principal em tela cheia */
.mobile-fullscreen-camera {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header fixo no topo */
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 0 20px;
}

.close-btn {
  position: absolute;
  left: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  padding: 10px;
  cursor: pointer;
}

.header-title {
  color: white;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 500;
}

/* Container da câmera ocupa toda a tela */
.camera-fullscreen-container {
  flex: 1;
  position: relative;
  width: 100%;
  height: 100%;
  margin-top: 60px;
  margin-bottom: 100px;
}

/* Vídeo da câmera em tela cheia */
.camera-video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.mobile-camera-video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  transform: scaleX(-1) !important;
  -webkit-transform: scaleX(-1) !important;
}

.mobile-camera-video video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  transform: scaleX(-1) !important;
  -webkit-transform: scaleX(-1) !important;
}

/* Canvas overlay em tela cheia */
.mobile-overlay-canvas {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  transform: scaleX(-1) !important;
  -webkit-transform: scaleX(-1) !important;
  pointer-events: none;
  z-index: 10;
}

/* Footer fixo na parte inferior */
.mobile-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 20px;
}

/* Botão de captura grande e visível */
.mobile-capture-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #007bff;
  border: 4px solid white;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}

.mobile-capture-button:hover:not(:disabled) {
  background: #0056b3;
  transform: scale(1.05);
}

.mobile-capture-button:disabled {
  background: #6c757d;
  border-color: #adb5bd;
  cursor: not-allowed;
  opacity: 0.6;
}

.capture-button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.capture-button-content i {
  font-size: 1.5rem;
  margin-bottom: 2px;
}

.capture-button-content span {
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1;
}

/* Garantir que não há scroll */
body.mobile-camera-active {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
}

/* Ajustes para dispositivos muito pequenos */
@media (max-width: 360px) {
  .mobile-capture-button {
    width: 70px;
    height: 70px;
  }

  .capture-button-content i {
    font-size: 1.3rem;
  }

  .capture-button-content span {
    font-size: 0.6rem;
  }

  .header-title {
    font-size: 1rem;
  }
}

/* Ajustes para dispositivos em landscape */
@media (orientation: landscape) {
  .mobile-header {
    height: 50px;
  }

  .camera-fullscreen-container {
    margin-top: 50px;
    margin-bottom: 80px;
  }

  .mobile-footer {
    height: 80px;
    padding: 15px;
  }

  .mobile-capture-button {
    width: 60px;
    height: 60px;
  }
}
</style>
